import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

class SuspensionAnalytics extends BaseAnalytics {
    constructor(category = 'management') {
        super();

        this.category = category;
    }

    openSuspensionPopup(label: 'widget' | 'alert') {
        this.send('click_new_suspent_service', label);
    }

    showActive() {
        this.send('tap_to_active_services');
    }

    showSuspended() {
        this.send('tap_to_suspend_services');
    }

    chooseService() {
        this.send('stop services suspend', 'choose services suspend');
    }

    chooseDates() {
        this.send('stop services suspend', 'choose date suspend');
    }

    suspend() {
        this.send('stop services suspend', 'click btn suspend');
    }

    successSuspended() {
        this.send('stop services suspend', 'succes suspend');
    }

    suspentionError() {
        this.send('stop services suspend', 'error suspend');
    }

    activate() {
        this.send('stop services activate', 'click btn activate');
    }

    successActivated() {
        this.send('stop services activate', 'succes services activate');
    }

    activationError() {
        this.send('stop services activate', 'error services activate');
    }

    changeDates() {
        this.send('tap_to_change_dates_from_suspension');
    }

    successChanged() {
        this.send('success_change_dates_from_suspension');
    }

    changingError() {
        this.send('error_change_dates_from_suspension');
    }
}

export const suspensionAnalytics = new SuspensionAnalytics();
